import { IDirectionDetail } from 'entities/ticket/ui/direction-detail'

import { Transport } from 'shared/api/tours/flights/model'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList.ts'
import { showWrongDateFormat } from 'shared/lib/dateFormat.ts'

export function prepareFlightDataForInfoOrders(
  transports: Transport[],
): IDirectionDetail[] {
  return transports.map((segment) => {
    const firstDep = segment.departure[0]
    const lastArr = segment.arrival[0]
    const totalDuration = parseInt(segment.durationMinutes || '0')

    const details = segment?.details?.[0]?.detail || []

    if (details?.length) {
      return {
        title: `${firstDep.town} - ${lastArr.town}`,
        flyItems: details?.map((detail, detailIndex) => {
          return {
            class: detail.class_,
            flight: detail?.flight_number || '',
            // baggage: detail?.bagage_note || '',
            // cbaggage: segment.cbaggage.weight,

            airPlane: {
              icon: segment?.logo_url || '',
              name: detail?.full_marketing_airline || '',
              timeFly: parseInt(detail?.fly_duration_min || '0'),
            },

            dep: {
              time: detail?.depart_time || '',
              date: showWrongDateFormat(
                detail?.depart_datetime,
                DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY_SEPARATE,
                ',',
              ),
              city: detail?.departure_airport_name?.split(',')?.[0] || '',
              code: detail?.departure_airport_code || '',
              terminal: '',
            },

            arr: {
              time: detail?.arrival_time || '',
              date: showWrongDateFormat(
                detail?.arrival_datetime,
                DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY_SEPARATE,
                ',',
              ),
              city: detail?.arrival_airport_name?.split(',')?.[0] || '',
              code: detail?.arrival_airport_code || '',
              terminal: '',
            },

            transfer:
              detailIndex < details?.length - 1
                ? {
                    name: detail?.arrival_airport_name?.split(',')?.[0] || '',
                    time: parseInt(detail?.fly_duration_min || '0'),
                    duration: parseInt(detail?.fly_duration_min || '0'),
                  }
                : undefined,
          }
        }),
      }
    }

    return {
      title: `${firstDep.town} - ${lastArr.town}`,
      flyItems: [
        {
          airPlane: {
            name: segment?.transportCompany || '',
            icon: segment?.logo_url || '',
            timeFly: totalDuration,
          },
          dep: {
            time: firstDep?.time || '',
            date: showWrongDateFormat(
              segment.datebeg,
              DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY_SEPARATE,
              ',',
            ),
            city: firstDep?.town || '',
            code: firstDep?.portAlias || '',
            terminal: '',
          },
          arr: {
            time: lastArr?.time || '',
            date: showWrongDateFormat(
              segment.dateend,
              DATE_FORMAT_LIST.DAY_MONTH_WEEK_DAY_SEPARATE,
              ',',
            ),
            city: lastArr?.town || '',
            code: lastArr?.portAlias || '',
            terminal: '',
          },
          flight: segment?.name || '',
          baggage: segment.baggage.weight,
          cbaggage: segment.cbaggage.weight,
          class: segment.class_,
        },
      ],
    }
  })
}
